import barba from '@barba/core'
import PageState from './page-state'
import PageHooks from './page-hooks'
import PageComponent from './page-component'
import PageSubset from './page-subset'
import { isTriggerFoward, isTriggerBack } from './popstate-trigger'

export {
    barba,
    PageHooks,
    PageComponent,
    PageState,
    PageSubset,
    isTriggerFoward,
    isTriggerBack
}
export default barba